export default class Puntal {}
export default class Puntal {}
